module.exports = __webpack_public_path__ + "static/media/home.0662cc27.png";